var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
class ListKeyboardDelegate {
  constructor(collection) {
    __publicField(this, "collection");
    __publicField(this, "count");
    this.collection = collection;
    this.count = collection.index.size;
  }
  getKeyAbove(k) {
    return k > 0 ? k - 1 : null;
  }
  getKeyBelow(k) {
    return k < this.count - 1 ? k + 1 : null;
  }
  getFirstKey() {
    return this.count ? 0 : null;
  }
  getLastKey() {
    return this.count - 1;
  }
  getKeyForSearch(search) {
    const i = Array.from(this.collection.index.values()).findIndex(
      (item) => item.label.toLowerCase().startsWith(search)
    );
    return i < 0 ? null : i;
  }
}
export {
  ListKeyboardDelegate
};
//# sourceMappingURL=KeyboardDelegate.es.js.map
